import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import ActionButton from '@repo/ui/action-button'
import { DeleteIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import { LanguageTestTemplate } from '../../../lib/types/models/language-test/language-test-template'
import CountryFlag from '../../elements/country-flag'
import LanguageTestTemplateDeleteModal from './language-test-template-delete-modal'

interface LanguageTestHeaderProps {
  template: LanguageTestTemplate
  onDeleteSuccess: () => void
}

const LanguageTestHeader = ({ template, onDeleteSuccess }: LanguageTestHeaderProps) => {
  const { toggleModal, closeModel, modalState } =
    useModalManager<'language-test-template-delete-modal'>(['language-test-template-delete-modal'])

  return (
    <div className="flex items-center justify-between p-4 bg-primary-light border border-primary-light-active rounded-lg">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2.5">
          {template.countries.map(({ code }) => (
            <CountryFlag key={code} size="large" code={code} />
          ))}
        </div>
        <Typography variant="sub-heading" color={tailwindColors.primary.DEFAULT}>
          {template.name}
        </Typography>
      </div>

      <ActionButton
        variant="danger"
        icon={DeleteIcon}
        onClick={() => toggleModal('language-test-template-delete-modal')}
      />

      <LanguageTestTemplateDeleteModal
        template={template}
        open={modalState['language-test-template-delete-modal']}
        onClose={() => closeModel('language-test-template-delete-modal')}
        onSuccess={onDeleteSuccess}
      />
    </div>
  )
}

export default LanguageTestHeader
